module.exports = __webpack_public_path__ + "static/media/logo.11f5a3a4.png";